import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

// import { TranslateService } from '@ngx-translate/core';
// import { IntlService } from '@progress/kendo-angular-intl';
import { AutoUnsubscribe } from '../../../../core/decorators/auto-unsubscribe';

@Component({
    selector: 'download-excel',
    templateUrl: './download-excel.component.html',
    styleUrls: ['./download-excel.component.scss']
  })
  @AutoUnsubscribe()
  export class DownloadExcelComponent implements OnInit {

    @Input() file: any;
    @Input() dfichero: string;
    @Output() modalClose = new EventEmitter<any>();

    constructor(
       ) { }

        ngOnInit() {
     }

      closeModal(result?: any) {
          //   const params = {
          //     'pantalla': 'downloadExcel',
          //     'datosForm': null
          // };


        this.modalClose.emit('cerrar');
      }


}
